import { render, staticRenderFns } from "./TalimatListesi.vue?vue&type=template&id=b0722d60&scoped=true&"
import script from "./TalimatListesi.vue?vue&type=script&lang=js&"
export * from "./TalimatListesi.vue?vue&type=script&lang=js&"
import style0 from "./TalimatListesi.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TalimatListesi.vue?vue&type=style&index=1&id=b0722d60&lang=scss&scoped=true&"
import style2 from "./TalimatListesi.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./TalimatListesi.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0722d60",
  null
  
)

export default component.exports